import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["name", "value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_select, {
      options: _ctx.selectOptions,
      modelValue: _ctx.selectedOptions,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedOptions) = $event)),
      multiple: "",
      searchable: false
    }, null, 8, ["options", "modelValue"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedOptions, (selectedOption) => {
      return (_openBlock(), _createElementBlock("input", {
        type: "hidden",
        name: _ctx.name,
        value: selectedOption.value
      }, null, 8, _hoisted_1))
    }), 256))
  ]))
}